if (!customElements.get('gf-product-details')) {
  customElements.define('gf-product-details', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      const button = this.querySelector('button[aria-controls]');
      if (!button) return;
      this.controller = new AbortController();
      button.addEventListener('click', () => {
        const details = document.getElementById(button.getAttribute('aria-controls'));
        if (!details) return;
        details.open = true;
        details.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        details.querySelector('summary')?.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
function tidyProductDescription(root) {
  root.querySelectorAll('.gf-product-page .product__description').forEach(description => {
    for (let pass = 0; pass < 4; pass++) {
      description.querySelectorAll('p,li,ul,ol').forEach(element => {
        if (!element.textContent.replace(/\u00a0/g, '').trim() && !element.querySelector('img,video,iframe,table,svg')) element.remove();
      });
    }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => tidyProductDescription(document), { once: true });
else tidyProductDescription(document);
document.addEventListener('shopify:section:load', event => tidyProductDescription(event.target));

if (!customElements.get('gf-product-photo-note')) {
  customElements.define('gf-product-photo-note', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.gallery = document.getElementById(this.dataset.galleryId);
      this.list = this.gallery?.querySelector('.product__media-list');
      this.text = this.querySelector('[data-gf-photo-note-text]');
      if (!this.list || !this.text) return;
      this.controller = new AbortController();
      this.refresh = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateNote(); });
      };
      const options = {passive: true, signal: this.controller.signal};
      this.list.addEventListener('scroll', this.refresh, options);
      this.gallery.addEventListener('slideChanged', this.refresh, options);
      window.addEventListener('resize', this.refresh, options);
      window.addEventListener('pageshow', this.refresh, options);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.list, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.resizeObserver.observe(this.list);
      this.updateNote();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
    updateNote() {
      const items = [...this.list.children].filter(item => item.dataset.mediaId && item.getBoundingClientRect().width > 0);
      if (!items.length) return;
      let active = items.find(item => item.classList.contains('is-active')) || items[0];
      if (window.matchMedia('(max-width: 749px)').matches) {
        const left = this.list.getBoundingClientRect().left;
        active = items.reduce((best, item) => Math.abs(item.getBoundingClientRect().left - left) < Math.abs(best.getBoundingClientRect().left - left) ? item : best, items[0]);
      }
      const token = ',' + active.dataset.mediaId.split('-').pop() + ',';
      let message = '';
      if (this.dataset.sofaMedia.includes(token)) message = this.dataset.sofaNote;
      else if (this.dataset.configurationMedia.includes(token)) message = this.dataset.configurationNote;
      this.text.textContent = message || this.dataset.configurationNote;
      this.setAttribute('aria-hidden', String(!message));
    }
  });
}
